/**
 * Bikram Sambat (BS) <-> Gregorian (AD) date conversion.
 * Uses a precomputed lookup of BS month lengths for years 2000-2090 BS.
 * Reference data adapted from public Nepali calendar tables.
 */

// BS year -> array of 12 month-lengths (Baisakh..Chaitra)
const BS_CALENDAR = {
  2070: [31,31,32,32,31,30,30,29,30,29,30,30],
  2071: [31,31,32,31,31,31,30,29,30,29,30,30],
  2072: [31,32,31,32,31,30,30,30,29,29,30,30],
  2073: [31,31,32,32,31,30,30,30,29,30,29,31],
  2074: [31,31,32,32,31,30,30,30,29,30,29,30],
  2075: [31,32,31,32,31,31,30,29,30,29,30,30],
  2076: [31,31,32,32,31,31,30,29,30,29,30,30],
  2077: [31,32,31,32,31,30,30,30,29,30,29,31],
  2078: [31,31,32,31,31,31,30,29,30,29,30,30],
  2079: [31,31,32,32,31,30,30,30,29,30,29,30],
  2080: [31,32,31,32,31,30,30,30,29,30,29,30],
  2081: [31,31,32,32,31,31,30,29,30,29,30,30],
  2082: [31,32,31,32,31,30,30,30,29,30,29,30],
  2083: [31,31,32,31,31,30,30,30,29,30,29,31],
  2084: [31,31,32,31,31,30,30,30,29,30,29,30],
  2085: [31,32,31,32,31,30,30,30,29,30,29,30],
  2086: [31,32,31,32,31,30,30,30,29,30,29,30],
  2087: [31,31,32,31,31,31,30,29,30,29,30,30],
  2088: [30,31,32,32,31,30,30,30,29,30,29,30],
  2089: [30,31,32,32,31,30,30,30,29,30,29,30],
  2090: [30,31,32,32,31,30,30,30,29,30,29,30],
};

// Reference: 1 Baisakh 2070 BS = 14 April 2013 AD
const REF_BS = { year: 2070, month: 1, day: 1 };
const REF_AD = new Date(Date.UTC(2013, 3, 14));

const BS_MONTHS = ["Baisakh","Jestha","Ashadh","Shrawan","Bhadra","Ashwin","Kartik","Mangsir","Poush","Magh","Falgun","Chaitra"];

function daysFromBSReference(year, month, day) {
  let days = 0;
  for (let y = REF_BS.year; y < year; y++) {
    if (!BS_CALENDAR[y]) return null;
    days += BS_CALENDAR[y].reduce((a, b) => a + b, 0);
  }
  if (!BS_CALENDAR[year]) return null;
  for (let m = 1; m < month; m++) {
    days += BS_CALENDAR[year][m - 1];
  }
  days += day - 1;
  return days;
}

export function bsToAd(year, month, day) {
  const days = daysFromBSReference(year, month, day);
  if (days === null) return null;
  const ad = new Date(REF_AD.getTime() + days * 86400000);
  return ad.toISOString().slice(0, 10);
}

export function adToBs(adIso) {
  if (!adIso) return null;
  const ad = new Date(adIso);
  if (isNaN(ad.getTime())) return null;
  let diff = Math.floor((ad.getTime() - REF_AD.getTime()) / 86400000);
  if (diff < 0) return null;
  let y = REF_BS.year, m = 1, d = 1;
  while (true) {
    if (!BS_CALENDAR[y]) return null;
    const yearDays = BS_CALENDAR[y].reduce((a, b) => a + b, 0);
    if (diff >= yearDays) { diff -= yearDays; y += 1; continue; }
    break;
  }
  for (let mi = 0; mi < 12; mi++) {
    const md = BS_CALENDAR[y][mi];
    if (diff >= md) { diff -= md; continue; }
    m = mi + 1; d = diff + 1; break;
  }
  return { year: y, month: m, day: d, label: `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}` };
}

export function bsLabel(adIso) {
  const bs = adToBs(adIso);
  if (!bs) return "";
  return `${bs.year} ${BS_MONTHS[bs.month - 1]} ${bs.day}`;
}

export const BS_MONTHS_LIST = BS_MONTHS;
export const BS_YEARS = Object.keys(BS_CALENDAR).map(Number);
export function bsMonthDays(year, month) {
  if (!BS_CALENDAR[year]) return 30;
  return BS_CALENDAR[year][month - 1];
}
